import React, { Component } from "react";
import "./approvals-landing.styles.scss";

// import { ReactComponent as UpcomingImage } from "../../assets/upcoming-auction.svg";
// import { ReactComponent as OpenImage } from "../../assets/open-auction.svg";
// import { ReactComponent as ArchiveImage } from "../../assets/archive.svg";
// import { ReactComponent as IntermediateImage } from "../../assets/intermediate.svg";
// import { ReactComponent as ApprovalImage } from "../../assets/approved.svg";
// import { ReactComponent as RefundImage } from "../../assets/refund.svg";

// import OpenAuction from "../open-auction/open-auction.page";
import EVRApprovalScreen from "../EVR approval-screen/EVR-approval-screen.page";
import EVRSubmitScreen from "../EVR submit-screen/EVR-submit-screen.page";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Dispatch } from "react";
import { canUserAccess } from "../../utils/utils";
import { FeatureCodes } from "../../constants/data-constants";

import { setViewAuctionPage } from "../../redux/common/common.actions";
import { selectViewAuctionPage } from "../../redux/common/common.selectors";

import { Tabs } from "antd";
import { selectUserData } from "../../redux/user/user.selectors";
import EVRBlockScreen from "../EVR-block-screen/EVR-block-screen.page";
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  useLocation,
  Redirect,
} from "react-router-dom";

const { TabPane } = Tabs;

const ApprovalsLanding: React.FC = (props: any) => {
  const { setViewAuctionPage, selectedKey, userData } = props;
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  return (
    <div className="view-auction-landing">
      <Tabs
        // defaultActiveKey={selectedKey}
        activeKey={location.pathname}
        onChange={(activeKey) => {
          // setViewAuctionPage(activeKey);
          history.push(activeKey);
        }}
      >
        {(canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_APPROVAL) ||
          canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS)) && (
          <TabPane tab={"Submit Vendor Code"} key={`${url}/submitvendorcode`} />
        )}
        {(canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS) ||
          canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_CHECKER)) && (
          <TabPane
            tab={"Approve Vendor Code"}
            key={`${url}/approvevendorcode`}
          />
        )}
        {(canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_APPROVAL) ||
          canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS) ||
          canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS) ||
          canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_CHECKER)) && (
          <TabPane
            tab={"Unblock Vendor Code"}
            key={`${url}/unblockvendorcode`}
          />
        )}
        {/* {(canUserAccess(userData, FeatureCodes.NEW_VENDOR_CHECKER) ||
          canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS)) && (
          <TabPane
            tab={
              <span className="tabname-container">
                {" "}
                <ApprovalImage className="tab-img" />{" "}
                <div className="tab-name">New Vendor Approval</div>
              </span>
            }
            key="2"
          >
            <ApprovalScreen {...props} />
          </TabPane>
        )} */}
        {/* {(canUserAccess(userData, FeatureCodes.REFUND_APPROVAL) ||
          canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS)) && (
          <TabPane
            tab={
              <span className="tabname-container">
                {" "}
                <ApprovalImage className="tab-img" />{" "}
                <div className="tab-name">Refund Approval</div>
              </span>
            }
            key="3"
          >
            <RefundApprovalScreen {...props} />
          </TabPane>
        )} */}
      </Tabs>
      <Switch>
        {(canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_APPROVAL) ||
          canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS)) && (
          <Route path={`${path}/submitvendorcode`}>
            <EVRSubmitScreen {...props} />
          </Route>
        )}
        {(canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS) ||
          canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_CHECKER)) && (
          <Route exact path={`${path}/approvevendorcode`}>
            <EVRApprovalScreen {...props} />
          </Route>
        )}
        <Route path={`${path}/unblockvendorcode`}>
          <EVRBlockScreen {...props} />
        </Route>
        {canUserAccess(userData, FeatureCodes.EXISTING_VENDOR_APPROVAL) ||
        canUserAccess(userData, FeatureCodes.PROCESS_APPROVALS) ? (
          <Redirect from={path} to={`${path}/submitvendorcode`} />
        ) : (
          <Redirect from={path} to={`${path}/approvevendorcode`} />
        )}
      </Switch>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedKey: selectViewAuctionPage,
  userData: selectUserData,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setViewAuctionPage: (activeKey: string) =>
      dispatch(setViewAuctionPage(activeKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalsLanding);
